import React from 'react';
import { PlayAudioIcon, PauseAudioIcon } from '@assets/icon';
import './AudioPlayerBar.scss';

const RATE_LABELS: Record<number, string> = {
  1: '1x',
  1.25: '1,25x',
  1.5: '1,5x',
  2: '2x',
};

const formatElapsed = (totalSeconds: number): string => {
  const safe = Math.max(0, Math.floor(totalSeconds));
  const minutes = Math.floor(safe / 60);
  const seconds = safe % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

interface AudioPlayerBarProps {
  isPaused: boolean;
  elapsedSeconds: number;
  playbackRate: number;
  onTogglePause: () => void;
  onCycleRate: () => void;
  onClose: () => void;
}

const renderPlayPauseBtn = (isPaused: boolean, onTogglePause: () => void) => (
  <button
    type="button"
    className="audio-player-bar__btn audio-player-bar__play"
    onClick={onTogglePause}
    aria-label={isPaused ? 'Phát' : 'Tạm dừng'}
  >
    {isPaused ? <PlayAudioIcon /> : <PauseAudioIcon />}
  </button>
);

const renderRateBtn = (rateLabel: string, onCycleRate: () => void) => (
  <button
    type="button"
    className="audio-player-bar__btn audio-player-bar__rate"
    onClick={onCycleRate}
    aria-label={`Tốc độ phát ${rateLabel}`}
  >
    {rateLabel}
  </button>
);

const renderCloseBtn = (onClose: () => void) => (
  <button
    type="button"
    className="audio-player-bar__btn audio-player-bar__close"
    onClick={onClose}
    aria-label="Tắt âm thanh"
  >
    <span className="audio-player-bar__close-icon" aria-hidden>
      ×
    </span>
  </button>
);

const AudioPlayerBar: React.FC<AudioPlayerBarProps> = ({
  isPaused,
  elapsedSeconds,
  playbackRate,
  onTogglePause,
  onCycleRate,
  onClose,
}) => {
  const rateLabel = RATE_LABELS[playbackRate] ?? `${String(playbackRate).replace('.', ',')}x`;

  return (
    <div className="audio-player-bar" role="group" aria-label="Đang phát âm thanh">
      {renderPlayPauseBtn(isPaused, onTogglePause)}
      <span className="audio-player-bar__time">{formatElapsed(elapsedSeconds)}</span>
      {renderRateBtn(rateLabel, onCycleRate)}
      {renderCloseBtn(onClose)}
    </div>
  );
};

export default AudioPlayerBar;
